// src/redux/appointment/appointment.actions.js
import { 
  firestore, 
  collection, 
  addDoc, 
  getDocs, 
  query, 
  orderBy 
} from '../../firebase/firebase.utils';

export const AppointmentActionTypes = {
  CREATE_APPOINTMENT: 'CREATE_APPOINTMENT',
  FETCH_APPOINTMENTS: 'FETCH_APPOINTMENTS',
  SET_APPOINTMENTS: 'SET_APPOINTMENTS',
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR'
};

// ===== CREATE APPOINTMENT =====
export const createAppointment = (appointmentData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: AppointmentActionTypes.SET_LOADING, payload: true });
      
      const appointmentsRef = collection(firestore, 'appointments');
      const newAppointment = {
        ...appointmentData,
        status: 'pending',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };
      
      const docRef = await addDoc(appointmentsRef, newAppointment);
      
      dispatch({ 
        type: AppointmentActionTypes.CREATE_APPOINTMENT, 
        payload: { id: docRef.id, ...newAppointment }
      });
      
      dispatch({ type: AppointmentActionTypes.SET_LOADING, payload: false });
      return { success: true, appointmentId: docRef.id };
      
    } catch (error) {
      console.error('Error creating appointment:', error);
      dispatch({ type: AppointmentActionTypes.SET_ERROR, payload: error.message });
      dispatch({ type: AppointmentActionTypes.SET_LOADING, payload: false });
      return { success: false, error: error.message };
    }
  };
};

// ===== FETCH ALL APPOINTMENTS =====
export const fetchAppointments = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: AppointmentActionTypes.SET_LOADING, payload: true });
      
      const appointmentsRef = collection(firestore, 'appointments');
      const q = query(appointmentsRef, orderBy('createdAt', 'desc'));
      const querySnapshot = await getDocs(q);
      
      const appointments = [];
      querySnapshot.forEach((doc) => {
        appointments.push({
          id: doc.id,
          ...doc.data()
        });
      });
      
      dispatch({ 
        type: AppointmentActionTypes.SET_APPOINTMENTS, 
        payload: appointments 
      });
      
      dispatch({ type: AppointmentActionTypes.SET_LOADING, payload: false });
      
    } catch (error) {
      console.error('Error fetching appointments:', error);
      dispatch({ type: AppointmentActionTypes.SET_ERROR, payload: error.message });
      dispatch({ type: AppointmentActionTypes.SET_LOADING, payload: false });
    }
  };
};